import React from 'react';
import PropTypes from 'prop-types';
import HouseAd from '../../components/HouseAd';
import styles from './page.css';

const PageContent = ({ header, content, footer }) => {
  const { overline, title, subtitle } = header;

  const splitContent = content.split('</p>');
  const splitIndex = Math.floor(splitContent.length / 2);

  const createMarkupFirstHalf = () => {
    const pageHeader = `
      <header>
        <h3>${overline}</h3>
        <h1>${title}</h1>
        ${subtitle ? `<h2>${subtitle}</h2>` : ''}
      </header>
    `;

    const htmlFirstHalfArr = splitContent.slice(0, splitIndex);
    const htmlFirstHalf = `${htmlFirstHalfArr.join('</p>')}</p>`;

    return { __html: pageHeader + htmlFirstHalf };
  };

  const createMarkupSecondHalf = () => {
    const htmlSecondHalfArr = splitContent.slice(splitIndex);
    const htmlSecondHalf = `${htmlSecondHalfArr.join('</p>')}`;

    const pageFooter = footer
      ? `
      <footer>
        ${footer}
      </footer>
    `
      : '';

    return { __html: htmlSecondHalf + pageFooter };
  };

  return (
    <>
      <div className={styles.body} dangerouslySetInnerHTML={createMarkupFirstHalf()} />
      <HouseAd />
      <div className={styles.body} dangerouslySetInnerHTML={createMarkupSecondHalf()} />
    </>
  );
};

PageContent.propTypes = {
  header: PropTypes.object.isRequired,
  content: PropTypes.string.isRequired,
  footer: PropTypes.string,
};

export default PageContent;
